import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
export var SegmentedLabel = styled(function (props) {
    var children = props.children, htmlAttributes = __rest(props, ["children"]);
    return (React.createElement("div", __assign({}, htmlAttributes, { "data-mui-segmented-label": "" }), children));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var templateObject_1;
//# sourceMappingURL=SegmentedLabel.js.map